import {Component, inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {ContainerComponent} from "@coreui/angular";
import {MatButton} from "@angular/material/button";
import {
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker,
  MatEndDate,
  MatStartDate
} from "@angular/material/datepicker";
import {MatFormField, MatHint, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatOption, MatSelect} from "@angular/material/select";
import {DateService} from "../../services/date.service";
import {GameService} from "../../services/game.service";
import {EmailTestingService} from "../../services/email-testing.service";
import {IEmailTemplateType} from "../../interfaces/IEmailTemplateType";
import {emailAuditStatusOptions} from "../../enum/EmailAuditStatusTypes";
import {
  EmailAuditTableComponent,
  EmailAuditTableFilter
} from "../../components/email-audit-table/email-audit-table.component";

const NoGame = 'no-game';

@Component({
  selector: 'app-sent-emails',
  standalone: true,
  imports: [
    ContainerComponent,
    EmailAuditTableComponent,
    MatButton,
    MatDateRangeInput,
    MatDateRangePicker,
    MatDatepickerToggle,
    MatEndDate,
    MatFormField,
    MatHint,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    MatStartDate,
    MatSuffix,
    ReactiveFormsModule
  ],
  templateUrl: './sent-emails.component.html'
})
export class SentEmailsComponent implements OnInit {
  private dateService = inject(DateService);
  private gameService = inject(GameService);
  private emailTestingService = inject(EmailTestingService);

  public readonly noGame = NoGame;
  public games = this.gameService.getAllAvailableGames();
  public emailTemplateTypes: IEmailTemplateType[] = [];
  public statusOptions = emailAuditStatusOptions;
  public filter: EmailAuditTableFilter | null = null;

  public recipientControl = new FormControl<string>('');
  public gameControl = new FormControl<string | null>(null);
  public emailTemplateTypeIdControl = new FormControl<number | null>(null);
  public statusControl = new FormControl<number | null>(null);
  public fromDateControl = new FormControl<Date>(this.dateService.twoWeeksAgo());
  public toDateControl = new FormControl<Date>(new Date());

  public filterFormGroup = new FormGroup({
    recipient: this.recipientControl,
    game: this.gameControl,
    emailTemplateTypeId: this.emailTemplateTypeIdControl,
    status: this.statusControl,
    fromDate: this.fromDateControl,
    toDate: this.toDateControl
  });

  ngOnInit() {
    this.emailTestingService.getEmailTemplateTypes().subscribe(typesP => this.emailTemplateTypes = typesP);
    this.applyFilter();
  }

  onFilterClick() {
    this.applyFilter();
  }

  onResetClick() {
    this.filterFormGroup.reset({
      recipient: '',
      game: null,
      emailTemplateTypeId: null,
      status: null,
      fromDate: this.dateService.twoWeeksAgo(),
      toDate: new Date()
    });

    this.applyFilter();
  }

  // A new object each time, so the table sees the change and reloads.
  private applyFilter() {
    const game = this.gameControl.value;

    this.filter = {
      recipient: this.recipientControl.value ?? '',
      gameId: game && game !== NoGame ? game : undefined,
      platformEmailsOnly: game === NoGame,
      emailTemplateTypeId: this.emailTemplateTypeIdControl.value,
      emailAuditStatusTypeId: this.statusControl.value,
      fromDate: this.fromDateControl.value ? new Date(this.fromDateControl.value) : undefined,
      toDate: this.toDateControl.value ? new Date(this.toDateControl.value) : undefined
    };
  }
}
